import React, { useState, useEffect } from 'react';
import DataStudioReports from 'src/pages/ReportsPages/DataStudio/DataStudioReports';
import reportsService from 'src/services/reportsService';
import filterArray from 'src/utils/filterArray';

const ReportDataStudio = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputSearch, setInputSearch] = useState('');

  /*= =======================================================================
  Get Reports DataStudio
======================================================================== */

  const getReportsDataStudio = async () => {
    const { data } = await reportsService.getReportByUserPermit();
    if (data) {
      setReports(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getReportsDataStudio();
  }, []);

  const onChangeInput = (event) => {
    setInputSearch(event.target.value.toLowerCase());
  };


  const filteredItems = filterArray(reports, 'nombre', inputSearch);

  return (
    <>
      <DataStudioReports
        onChangeInput={onChangeInput}
        reports={filteredItems}
        loading={loading}
      />
    </>
  );
};

export default ReportDataStudio;
